var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc jc ac p40"},[_c('img',{staticClass:"cert-img",attrs:{"src":_vm.cert_img,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }